import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

interface loginState {
	user: string,
	pass: string
}
interface changePassState {
	caseno: string,
	pass: string,
	session: string
}
interface introducerState {
	introducerid: string,
	introducer: string,
	panelReferDescription: string,
}
export interface developerState {
	developerid: string,
	developer: string,
	schemeid: string
}
export interface sitesState {
	developerid: string,
	siteid: string,
	site: string
}
export interface schemesState {
	schemeid: string,
	scheme: string
}
interface userState {
	user: string,
	pass: string,
	type: string,
	token: string,
	status: string,
	id: string,
	introducer: introducerState,
	developers: developerState[],
	schemes: schemesState[],
	sites: sitesState[],
	prevlogin: string,
	force: string | null
}

const uo = {
	user: '',
	pass: '',
	type: '',
	token: '',
	status: '',
	id: '',
	introducer: {
		introducerid: '',
		introducer: '',
		panelReferDescription: '',
	},
	developers: [],
	schemes: [],
	sites: [],
	prevlogin: '0',
	force: null
}
const initialState: userState = uo;

export const userLogin = createAsyncThunk(
	'user/login',
	async (login: loginState, _thunkAPI: any) => {
		let formdata = new FormData();
		formdata.append("login", login.user);
		formdata.append("pass", login.pass);

		       return fetch(process.env.REACT_APP_API_BACKEND_URL + 'loginhash.php', {
			       method: 'POST',
			       body: formdata,
			       credentials: 'include'
		       })
			.then(async (response) => {
				return await response.text();
			})
			.catch((error) => {
				console.error(error);
			});
	}
);

export const doUserLogout = createAsyncThunk(
	'user/logout',
	async () => {
		return fetch(process.env.REACT_APP_API_BACKEND_URL + 'logout.php', {
			method: 'GET',
		})
			.then(async (response) => {
				return await response.text();
			})
			.catch((error) => {
				console.error(error);
			});
	}
);

export const getProfile = createAsyncThunk(
	'user/getProfile',
	async () => {
		return fetch(process.env.REACT_APP_API_BACKEND_URL + 'getProfile.php', {
			method: 'GET',
			credentials: 'include'
		})
			.then(async (response) => {
				return await response.text();
			})
			.catch((error) => {
				console.error(error);
			});
	}
);

export const userChangePass = createAsyncThunk(
	'user/changepass',
	async (state: changePassState, _thunkAPI: any) => {
		let formdata = new FormData();
		formdata.append("caseno", state.caseno);
		formdata.append("pass", state.pass);
		formdata.append("session", state.session);

		return fetch(process.env.REACT_APP_API_BACKEND_URL + 'changepasswordhash.php', {
			method: 'POST',
			body: formdata
		})
			.then(async (response) => {
				return await response.text();
			})
			.catch((error) => {
				console.error(error);
			});
	}
);

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUser: (state: { user: any; }, action: PayloadAction<string>) => {
			state.user = action.payload;
		},
		setPass: (state: { pass: any; }, action: PayloadAction<string>) => {
			state.pass = action.payload;
		},
		userLogout: (state) => {
			state.token = '';
		}
	},
	extraReducers: (builder: { addCase: (arg0: any, arg1: (state: any, action: any) => void) => void; }) => {
		builder.addCase(userLogin.fulfilled, (state: userState, action: { payload: string; }) => {
			try {
				const json = JSON.parse(action.payload as string);
				state.type = json.type;
				state.token = json.token;
				state.status = json.status;
				state.id = json.refer;
				state.introducer = json.introducer;
				state.developers = json.developers;
				state.schemes = json.schemes;
				state.sites = json.sites;
				state.prevlogin = json.prevlogin;
				state.force = json.force;
			} catch (e) { }
		})
		builder.addCase(getProfile.fulfilled, (state: userState, action: { payload: string; }) => {
			try {
				const json = JSON.parse(action.payload as string);
				state.type = json.type;
				state.token = json.token;
				state.status = json.status;
				state.user = json.user;
				state.id = json.refer;
				state.introducer = json.introducer;
				state.developers = json.developers;
				state.schemes = json.schemes;
				state.sites = json.sites;
				state.prevlogin = json.prevlogin;
				state.force = json.force;
			} catch (e) { }
		})
		builder.addCase(userChangePass.fulfilled, (state: userState, action: { payload: string; }) => {
		})
	}
})

export const { setUser, setPass, userLogout } = userSlice.actions;
export default userSlice.reducer;